export const FBS_DEFAULT_LANGUAGE = "en";

const BUILTIN_LANGUAGES = {
    en: {
        key: "en",
        label: "English",
        nativeLabel: "English",
        dir: "ltr",
    },
    hi: {
        key: "hi",
        label: "Hindi",
        nativeLabel: "हिन्दी",
        dir: "ltr",
    },
    ar: {
        key: "ar",
        label: "Arabic",
        nativeLabel: "العربية",
        dir: "rtl",
    },
    ml: {
        key: "ml",
        label: "Malayalam",
        nativeLabel: "മലയാളം",
        dir: "ltr",
    },
    ta: {
        key: "ta",
        label: "Tamil",
        nativeLabel: "தமிழ்",
        dir: "ltr",
    },
    te: {
        key: "te",
        label: "Telugu",
        nativeLabel: "తెలుగు",
        dir: "ltr",
    },
    kn: {
        key: "kn",
        label: "Kannada",
        nativeLabel: "ಕನ್ನಡ",
        dir: "ltr",
    },
    bn: {
        key: "bn",
        label: "Bengali",
        nativeLabel: "বাংলা",
        dir: "ltr",
    },
    mr: {
        key: "mr",
        label: "Marathi",
        nativeLabel: "मराठी",
        dir: "ltr",
    },
    gu: {
        key: "gu",
        label: "Gujarati",
        nativeLabel: "ગુજરાતી",
        dir: "ltr",
    },
    pa: {
        key: "pa",
        label: "Punjabi",
        nativeLabel: "ਪੰਜਾਬੀ",
        dir: "ltr",
    },
    ur: {
        key: "ur",
        label: "Urdu",
        nativeLabel: "اردو",
        dir: "rtl",
    },
    fr: {
        key: "fr",
        label: "French",
        nativeLabel: "Français",
        dir: "ltr",
    },
    es: {
        key: "es",
        label: "Spanish",
        nativeLabel: "Español",
        dir: "ltr",
    },
    de: {
        key: "de",
        label: "German",
        nativeLabel: "Deutsch",
        dir: "ltr",
    },
};

// NOTE: Keep this language catalog in sync with vesta.web.admin/src/pages/fbs/fbsTranslations.ts
// whenever you add or rename supported languages.

const STATIC_TEXT = {
    "rating.bad": {
        en: "Bad",
        hi: "बहुत खराब",
        ar: "سيئ",
        bn: "খারাপ",
        ur: "برا",
    },
    "rating.poor": {
        en: "Poor",
        hi: "खराब",
        ar: "ضعيف",
        bn: "দুর্বল",
        ur: "ناقص",
    },
    "rating.average": {
        en: "Average",
        hi: "औसत",
        ar: "متوسط",
        bn: "গড়",
        ur: "اوسط",
    },
    "rating.good": {
        en: "Good",
        hi: "अच्छा",
        ar: "جيد",
        bn: "ভালো",
        ur: "اچھا",
    },
    "rating.veryGood": {
        en: "Very Good",
        hi: "बहुत अच्छा",
        ar: "جيد جدًا",
        bn: "খুব ভালো",
        ur: "بہت اچھا",
    },
    "rating.excellent": {
        en: "Excellent",
        hi: "उत्कृष्ट",
        ar: "ممتاز",
        bn: "চমৎকার",
        ur: "بہترین",
    },
    "rating.fair": {
        en: "Fair",
        hi: "ठीक-ठाक",
        ar: "مقبول",
        bn: "মোটামুটি",
        ur: "ٹھیک",
    },
    "rating.thankYou": {
        en: "Thank you for your feedback",
        hi: "आपकी प्रतिक्रिया के लिए धन्यवाद",
        ar: "شكرًا لك على ملاحظاتك",
        bn: "আপনার মতামতের জন্য ধন্যবাদ",
        ur: "آپ کی رائے کا شکریہ",
    },
    "rating.whereImprove": {
        en: "Where can we improve?",
        hi: "हम कहाँ सुधार कर सकते हैं?",
        ar: "أين يمكننا التحسين؟",
        bn: "আমরা কোথায় উন্নতি করতে পারি?",
        ur: "ہم کہاں بہتری لا سکتے ہیں؟",
    },
    "rating.makeRight": {
        en: "How can we make things right?",
        hi: "हम चीजों को बेहतर कैसे कर सकते हैं?",
        ar: "كيف يمكننا تصحيح الأمور؟",
        bn: "আমরা কীভাবে সংশোধন করতে পারি?",
        ur: "ہم چیزوں کو کیسے درست کر سکتے ہیں؟",
    },
    "screen.rateExperience": {
        en: "Please rate your experience",
        hi: "कृपया अपने अनुभव को रेट करें",
        ar: "يرجى تقييم تجربتك",
        bn: "অনুগ্রহ করে আপনার অভিজ্ঞতা মূল্যায়ন করুন",
        ur: "براہ کرم اپنے تجربے کی درجہ بندی کریں",
    },
    "screen.whatNeedsImprovement": {
        en: "What needs improvement?",
        hi: "क्या सुधार की आवश्यकता है?",
        ar: "ما الذي يحتاج إلى تحسين؟",
        bn: "কিসের উন্নতি প্রয়োজন?",
        ur: "کس چیز میں بہتری کی ضرورت ہے؟",
    },
    "screen.whatLikedServices": {
        en: "What did you like about our services?",
        hi: "आपको हमारी सेवाओं में क्या पसंद आया?",
        ar: "ما الذي أعجبك في خدماتنا؟",
        bn: "আমাদের সেবায় আপনার কী ভালো লেগেছে?",
        ur: "آپ کو ہماری خدمات میں کیا پسند آیا؟",
    },
    "screen.weWouldLoveToHear": {
        en: "We would love to hear from you",
        hi: "हम आपकी राय जानना चाहेंगे",
        ar: "يسعدنا أن نسمع منك",
        bn: "আমরা আপনার মতামত শুনতে চাই",
        ur: "ہم آپ سے سننا چاہیں گے",
    },
    "screen.helpUsServeBetter": {
        en: "Help us serve you better",
        hi: "हमें आपकी बेहतर सेवा करने में मदद करें",
        ar: "ساعدنا على خدمتك بشكل أفضل",
        bn: "আমাদের আরও ভালো সেবা দিতে সাহায্য করুন",
        ur: "بہتر خدمت کرنے میں ہماری مدد کریں",
    },
    "screen.touchToProvideFeedback": {
        en: "Kindly touch the screen to provide feedback",
        hi: "प्रतिक्रिया देने के लिए कृपया स्क्रीन को स्पर्श करें",
        ar: "يرجى لمس الشاشة لتقديم ملاحظاتك",
        bn: "মতামত দিতে অনুগ্রহ করে স্ক্রিনে স্পর্শ করুন",
        ur: "رائے دینے کے لیے براہ کرم اسکرین کو ٹچ کریں",
    },
    "screen.expired": {
        en: "Feedback QR expired!",
        hi: "फीडबैक क्यूआर समाप्त हो गया है!",
        ar: "انتهت صلاحية رمز الاستجابة السريعة للتقييم!",
        bn: "ফিডব্যাক কিউআর মেয়াদ শেষ!",
        ur: "فیڈبیک کیو آر کی مدت ختم ہو گئی!",
    },
    "screen.loading": {
        en: "Loading ...",
        hi: "लोड हो रहा है ...",
        ar: "جارٍ التحميل ...",
        bn: "লোড হচ্ছে ...",
        ur: "لوڈ ہو رہا ہے ...",
    },
    "screen.submittingFeedback": {
        en: "Your feedback is being submitted",
        hi: "आपकी प्रतिक्रिया सबमिट की जा रही है",
        ar: "يتم إرسال ملاحظاتك",
        bn: "আপনার মতামত জমা দেওয়া হচ্ছে",
        ur: "آپ کی رائے جمع کی جا رہی ہے",
    },
    "screen.pleaseWait": {
        en: "Please wait...",
        hi: "कृपया प्रतीक्षा करें...",
        ar: "يرجى الانتظار...",
        bn: "অনুগ্রহ করে অপেক্ষা করুন...",
        ur: "براہ کرم انتظار کریں...",
    },
    "screen.pleaseRateServices": {
        en: "Please rate our services",
        hi: "कृपया हमारी सेवाओं को रेट करें",
        ar: "يرجى تقييم خدماتنا",
        bn: "অনুগ্রহ করে আমাদের সেবা মূল্যায়ন করুন",
        ur: "براہ کرم ہماری خدمات کی درجہ بندی کریں",
    },
    "screen.whatIssuesExperienced": {
        en: "What issues did you experience?",
        hi: "आपको किन समस्याओं का सामना करना पड़ा?",
        ar: "ما المشكلات التي واجهتها؟",
        bn: "আপনি কী সমস্যার সম্মুখীন হয়েছেন?",
        ur: "آپ کو کن مسائل کا سامنا ہوا؟",
    },
    "action.giveAdditionalFeedback": {
        en: "Give Additional feedback",
        hi: "अतिरिक्त प्रतिक्रिया दें",
        ar: "قدّم ملاحظات إضافية",
        bn: "অতিরিক্ত মতামত দিন",
        ur: "اضافی رائے دیں",
    },
    "action.submitFeedback": {
        en: "Submit feedback",
        hi: "प्रतिक्रिया सबमिट करें",
        ar: "إرسال الملاحظات",
        bn: "মতামত জমা দিন",
        ur: "رائے جمع کروائیں",
    },
    "action.sendCode": {
        en: "Send Code",
        hi: "कोड भेजें",
        ar: "إرسال الرمز",
        bn: "কোড পাঠান",
        ur: "کوڈ بھیجیں",
    },
    "action.resendCode": {
        en: "Resend Code",
        hi: "कोड दोबारा भेजें",
        ar: "إعادة إرسال الرمز",
        bn: "কোড পুনরায় পাঠান",
        ur: "کوڈ دوبارہ بھیجیں",
    },
    "action.validateCode": {
        en: "Validate Code",
        hi: "कोड सत्यापित करें",
        ar: "التحقق من الرمز",
        bn: "কোড যাচাই করুন",
        ur: "کوڈ کی تصدیق کریں",
    },
    "action.next": {
        en: "Next",
        hi: "आगे",
        ar: "التالي",
        bn: "পরবর্তী",
        ur: "اگلا",
    },
    "action.language": {
        en: "Language",
        hi: "भाषा",
        ar: "اللغة",
        bn: "ভাষা",
        ur: "زبان",
    },
    "form.audioFeedback": {
        en: "Audio Feedback",
        hi: "ऑडियो प्रतिक्रिया",
        ar: "ملاحظات صوتية",
        bn: "অডিও মতামত",
        ur: "آڈیو رائے",
    },
    "form.feedbackSuggestions": {
        en: "Your Feedback / Suggestions",
        hi: "आपकी प्रतिक्रिया / सुझाव",
        ar: "ملاحظاتك / اقتراحاتك",
        bn: "আপনার মতামত / পরামর্শ",
        ur: "آپ کی رائے / تجاویز",
    },
    "form.feedbackSuggestionsPreferredLanguage": {
        en: "Your Feedback / Suggestions in your preferred language",
        hi: "आपकी पसंदीदा भाषा में आपकी प्रतिक्रिया / सुझाव",
        ar: "ملاحظاتك / اقتراحاتك بلغتك المفضلة",
        bn: "আপনার পছন্দের ভাষায় আপনার মতামত / পরামর্শ",
        ur: "اپنی پسندیدہ زبان میں آپ کی رائے / تجاویز",
    },
    "form.optional": {
        en: "(Optional)",
        hi: "(वैकल्पिक)",
        ar: "(اختياري)",
        bn: "(ঐচ্ছিক)",
        ur: "(اختیاری)",
    },
    "form.feedbackPlaceholder": {
        en: "Help us serve you better",
        hi: "हमें आपकी बेहतर सेवा करने में मदद करें",
        ar: "ساعدنا على خدمتك بشكل أفضل",
        bn: "আমাদের আরও ভালো সেবা দিতে সাহায্য করুন",
        ur: "بہتر خدمت کرنے میں ہماری مدد کریں",
    },
    "form.minimumCharacters": {
        en: "Minimum 10 characters",
        hi: "कम से कम 10 अक्षर",
        ar: "10 أحرف على الأقل",
        bn: "সর্বনিম্ন ১০টি অক্ষর",
        ur: "کم از کم 10 حروف",
    },
    "form.pleaseSelectAirline": {
        en: "Please Select Airline",
        hi: "कृपया एयरलाइन चुनें",
        ar: "يرجى اختيار شركة الطيران",
        bn: "অনুগ্রহ করে এয়ারলাইন নির্বাচন করুন",
        ur: "براہ کرم ایئر لائن منتخب کریں",
    },
    "form.selectAirline": {
        en: "Select airline",
        hi: "एयरलाइन चुनें",
        ar: "اختر شركة الطيران",
        bn: "এয়ারলাইন নির্বাচন করুন",
        ur: "ایئر لائن منتخب کریں",
    },
    "form.yourName": {
        en: "Your Name",
        hi: "आपका नाम",
        ar: "اسمك",
        bn: "আপনার নাম",
        ur: "آپ کا نام",
    },
    "form.nameRequired": {
        en: "Name Required",
        hi: "नाम आवश्यक है",
        ar: "الاسم مطلوب",
        bn: "নাম আবশ্যক",
        ur: "نام ضروری ہے",
    },
    "form.invalidName": {
        en: "Invalid Name",
        hi: "अमान्य नाम",
        ar: "اسم غير صالح",
        bn: "অবৈধ নাম",
        ur: "غلط نام",
    },
    "form.bialInfo": {
        en: "Please help us with your contact details for feedback response.",
        hi: "कृपया प्रतिक्रिया उत्तर के लिए अपने संपर्क विवरण साझा करें।",
        ar: "يرجى مساعدتنا بتفاصيل الاتصال الخاصة بك للرد على الملاحظات.",
        bn: "মতামতের উত্তরের জন্য অনুগ্রহ করে আপনার যোগাযোগের তথ্য দিন।",
        ur: "رائے کے جواب کے لیے براہ کرم اپنے رابطے کی تفصیلات فراہم کریں۔",
    },
    "form.yourContactNumber": {
        en: "Your Contact Number",
        hi: "आपका संपर्क नंबर",
        ar: "رقم الاتصال الخاص بك",
        bn: "আপনার যোগাযোগ নম্বর",
        ur: "آپ کا رابطہ نمبر",
    },
    "form.mobileRequired": {
        en: "Mobile number required",
        hi: "मोबाइल नंबर आवश्यक है",
        ar: "رقم الجوال مطلوب",
        bn: "মোবাইল নম্বর আবশ্যক",
        ur: "موبائل نمبر ضروری ہے",
    },
    "form.enterMobileNumber": {
        en: "Enter your mobile number",
        hi: "अपना मोबाइल नंबर दर्ज करें",
        ar: "أدخل رقم جوالك",
        bn: "আপনার মোবাইল নম্বর লিখুন",
        ur: "اپنا موبائل نمبر درج کریں",
    },
    "form.searchCountry": {
        en: "Search country",
        hi: "देश खोजें",
        ar: "ابحث عن الدولة",
        bn: "দেশ খুঁজুন",
        ur: "ملک تلاش کریں",
    },
    "form.invalidMobileNumber": {
        en: "Invalid mobile number",
        hi: "अमान्य मोबाइल नंबर",
        ar: "رقم الجوال غير صالح",
        bn: "অবৈধ মোবাইল নম্বর",
        ur: "غلط موبائل نمبر",
    },
    "form.yourEmailId": {
        en: "Your Email ID",
        hi: "आपकी ईमेल आईडी",
        ar: "بريدك الإلكتروني",
        bn: "আপনার ইমেইল আইডি",
        ur: "آپ کی ای میل آئی ڈی",
    },
    "form.emailRequired": {
        en: "Email Required",
        hi: "ईमेल आवश्यक है",
        ar: "البريد الإلكتروني مطلوب",
        bn: "ইমেইল আবশ্যক",
        ur: "ای میل ضروری ہے",
    },
    "form.invalidEmail": {
        en: "Invalid Email",
        hi: "ईमेल अमान्य है",
        ar: "بريد إلكتروني غير صالح",
        bn: "অবৈধ ইমেইল",
        ur: "غلط ای میل",
    },
    "form.organizationName": {
        en: "Organization / Agency Name",
        hi: "संगठन / एजेंसी का नाम",
        ar: "اسم المؤسسة / الوكالة",
        bn: "প্রতিষ্ঠান / সংস্থার নাম",
        ur: "ادارے / ایجنسی کا نام",
    },
    "form.orgNameRequired": {
        en: "Org Name Required",
        hi: "संगठन का नाम आवश्यक है",
        ar: "اسم المؤسسة مطلوب",
        bn: "প্রতিষ্ঠানের নাম আবশ্যক",
        ur: "ادارے کا نام ضروری ہے",
    },
    "form.feedbackCode": {
        en: "Feedback Code",
        hi: "फीडबैक कोड",
        ar: "رمز الملاحظات",
        bn: "ফিডব্যাক কোড",
        ur: "فیڈبیک کوڈ",
    },
    "form.enterFeedbackCode": {
        en: "Enter Feedback Code",
        hi: "फीडबैक कोड दर्ज करें",
        ar: "أدخل رمز الملاحظات",
        bn: "ফিডব্যাক কোড লিখুন",
        ur: "فیڈبیک کوڈ درج کریں",
    },
    "form.validateFeedbackCode": {
        en: "Please validate the Feedback Code",
        hi: "कृपया फीडबैक कोड सत्यापित करें",
        ar: "يرجى التحقق من رمز الملاحظات",
        bn: "অনুগ্রহ করে ফিডব্যাক কোড যাচাই করুন",
        ur: "براہ کرم فیڈبیک کوڈ کی تصدیق کریں",
    },
    "tnc.agree": {
        en: "I agree to the Terms and Conditions",
        hi: "मैं नियमों और शर्तों से सहमत हूँ",
        ar: "أوافق على الشروط والأحكام",
        bn: "আমি শর্তাবলীতে সম্মত",
        ur: "میں شرائط و ضوابط سے متفق ہوں",
    },
    "tnc.required": {
        en: "T&C acceptance required",
        hi: "नियम और शर्तों की स्वीकृति आवश्यक है",
        ar: "مطلوب قبول الشروط والأحكام",
        bn: "শর্তাবলী গ্রহণ আবশ্যক",
        ur: "شرائط و ضوابط کی منظوری ضروری ہے",
    },
    "otp.sent": {
        en: "✔ Feedback Code was sent to the mobile number",
        hi: "✔ फीडबैक कोड मोबाइल नंबर पर भेज दिया गया है",
        ar: "✔ تم إرسال رمز الملاحظات إلى رقم الجوال",
        bn: "✔ ফিডব্যাক কোড মোবাইল নম্বরে পাঠানো হয়েছে",
        ur: "✔ فیڈبیک کوڈ موبائل نمبر پر بھیج دیا گیا ہے",
    },
    "otp.validated": {
        en: "✔ Feedback Code successfully validated",
        hi: "✔ फीडबैक कोड सफलतापूर्वक सत्यापित हुआ",
        ar: "✔ تم التحقق من رمز الملاحظات بنجاح",
        bn: "✔ ফিডব্যাক কোড সফলভাবে যাচাই হয়েছে",
        ur: "✔ فیڈبیک کوڈ کامیابی سے تصدیق ہو گیا",
    },
    "otp.validationError": {
        en: "✖ Error validating Feedback Code. Please recheck and try again",
        hi: "✖ फीडबैक कोड सत्यापित करने में त्रुटि। कृपया दोबारा जांचें और फिर प्रयास करें",
        ar: "✖ حدث خطأ أثناء التحقق من رمز الملاحظات. يرجى المراجعة والمحاولة مرة أخرى",
        bn: "✖ ফিডব্যাক কোড যাচাইয়ে ত্রুটি। অনুগ্রহ করে পুনরায় পরীক্ষা করে চেষ্টা করুন",
        ur: "✖ فیڈبیک کوڈ کی تصدیق میں خرابی۔ براہ کرم دوبارہ چیک کریں اور کوشش کریں",
    },
    "otp.alreadySubmitted": {
        en: "This number has already submitted feedback in the last 30 days",
        hi: "इस नंबर से पिछले 30 दिनों में पहले ही प्रतिक्रिया दी जा चुकी है",
        ar: "تم إرسال ملاحظات من هذا الرقم بالفعل خلال آخر 30 يومًا",
        bn: "এই নম্বর থেকে গত ৩০ দিনে ইতিমধ্যে মতামত জমা দেওয়া হয়েছে",
        ur: "اس نمبر سے گزشتہ 30 دنوں میں پہلے ہی رائے جمع ہو چکی ہے",
    },
    "alert.deviceLimit": {
        en: "This device has already submitted the maximum number of feedbacks for today. Please try again tomorrow.",
        hi: "इस डिवाइस से आज की अधिकतम प्रतिक्रियाएँ पहले ही जमा हो चुकी हैं। कृपया कल फिर प्रयास करें।",
        ar: "أرسل هذا الجهاز بالفعل الحد الأقصى من الملاحظات لهذا اليوم. يرجى المحاولة غدًا.",
        bn: "এই ডিভাইস থেকে আজকের সর্বোচ্চ সংখ্যক মতামত ইতিমধ্যে জমা হয়েছে। অনুগ্রহ করে আগামীকাল আবার চেষ্টা করুন।",
        ur: "اس ڈیوائس سے آج کی زیادہ سے زیادہ رائے پہلے ہی جمع ہو چکی ہے۔ براہ کرم کل دوبارہ کوشش کریں۔",
    },
    "alert.verifyMobile": {
        en: "Please verify your mobile number using 'Validate Code'",
        hi: "कृपया 'Validate Code' का उपयोग करके अपना मोबाइल नंबर सत्यापित करें",
        ar: "يرجى التحقق من رقم جوالك باستخدام 'التحقق من الرمز'",
        bn: "অনুগ্রহ করে 'কোড যাচাই করুন' ব্যবহার করে আপনার মোবাইল নম্বর যাচাই করুন",
        ur: "براہ کرم 'کوڈ کی تصدیق کریں' استعمال کرکے اپنا موبائل نمبر تصدیق کریں",
    },
    "modal.feedbackId": {
        en: "Feedback ID",
        hi: "फीडबैक आईडी",
        ar: "معرّف الملاحظات",
        bn: "ফিডব্যাক আইডি",
        ur: "فیڈبیک آئی ڈی",
    },
    "common.required": { en: "*", hi: "*", ar: "*", bn: "*", ur: "*" },
    "label.ratingsCount": {
        en: "ratings",
        hi: "रेटिंग",
        ar: "تقييمات",
        ml: "റേറ്റിംഗുകൾ",
        ta: "மதிப்பீடுகள்",
        te: "రేటింగ్‌లు",
        kn: "ರೇಟಿಂಗ್‌ಗಳು",
        bn: "রেটিং",
        mr: "रेटिंग",
        gu: "રેટિંગ",
        pa: "ਰੇਟਿੰਗ",
        ur: "درجہ بندیاں",
        fr: "notes",
        es: "calificaciones",
        de: "Bewertungen",
    },
};

const RATING_VALUE_TO_STATIC_KEY = {
    Bad: "rating.bad",
    Poor: "rating.poor",
    Average: "rating.average",
    Good: "rating.good",
    "Very Good": "rating.veryGood",
    Excellent: "rating.excellent",
    Fair: "rating.fair",
    "Thank you for your feedback": "rating.thankYou",
    "Where can we improve?": "rating.whereImprove",
    "How can we make things right?": "rating.makeRight",
};

const normalizeLanguageKey = (value) => {
    const nextValue = String(value ?? "")
        .trim()
        .toLowerCase();
    return BUILTIN_LANGUAGES[nextValue] ? nextValue : FBS_DEFAULT_LANGUAGE;
};

export const getFbsOrgSettingValue = (
    settings,
    key,
    fallbackValue = null,
) => {
    if (Array.isArray(settings)) {
        return settings.find((item) => item?.key === key)?.value ?? fallbackValue;
    }

    if (settings && typeof settings === "object") {
        const directValue = settings[key];

        if (
            directValue &&
            typeof directValue === "object" &&
            Object.prototype.hasOwnProperty.call(directValue, "value")
        ) {
            return directValue.value ?? fallbackValue;
        }

        return directValue ?? fallbackValue;
    }

    return fallbackValue;
};

export const getStaticFbsText = (key, languageKey = FBS_DEFAULT_LANGUAGE) => {
    const normalizedKey = normalizeLanguageKey(languageKey);
    const item = STATIC_TEXT[key] ?? null;
    if (!item) {
        return key;
    }

    return item[normalizedKey] ?? item[FBS_DEFAULT_LANGUAGE] ?? key;
};

export const getLanguageDirection = (languageKey = FBS_DEFAULT_LANGUAGE) => {
    return BUILTIN_LANGUAGES[normalizeLanguageKey(languageKey)]?.dir ?? "ltr";
};

export const getFbsSupportedLanguages = (
    enabledIsoKeysRaw,
    enabled = false,
) => {
    if (!enabled) {
        return [BUILTIN_LANGUAGES.en];
    }

    const isoKeys = String(enabledIsoKeysRaw ?? "")
        .split(",")
        .map((isoKey) => isoKey.trim().toLowerCase())
        .filter((isoKey) => /^[a-z]{2,5}$/.test(isoKey));

    const normalized = isoKeys
        .filter((isoKey, index) => isoKeys.indexOf(isoKey) === index)
        .map((isoKey) => BUILTIN_LANGUAGES[isoKey] ?? null)
        .filter(Boolean)
        .filter(
            (language, index, collection) =>
                collection.findIndex((item) => item.key === language.key) ===
                index,
        );

    const withEnglish = normalized.some((language) => language.key === "en")
        ? normalized
        : [BUILTIN_LANGUAGES.en, ...normalized];

    return withEnglish.length > 0 ? withEnglish : [BUILTIN_LANGUAGES.en];
};

export const getFbsDefaultLanguage = (enabledIsoKeysRaw, enabled = false) => {
    if (!enabled) {
        return FBS_DEFAULT_LANGUAGE;
    }

    const supportedLanguages = getFbsSupportedLanguages(
        enabledIsoKeysRaw,
        enabled,
    );

    return supportedLanguages.some(
        (language) => language.key === FBS_DEFAULT_LANGUAGE,
    )
        ? FBS_DEFAULT_LANGUAGE
        : (supportedLanguages[0]?.key ?? FBS_DEFAULT_LANGUAGE);
};

export const resolveTemplateLabel = (
    entity,
    languageKey = FBS_DEFAULT_LANGUAGE,
) => {
    const normalizedKey = String(languageKey ?? "")
        .trim()
        .toLowerCase();
    const translations = entity?.translations ?? {};
    const directMatch = translations?.[normalizedKey]?.name;
    const englishMatch = translations?.[FBS_DEFAULT_LANGUAGE]?.name;

    return directMatch || englishMatch || entity?.name || "";
};

export const resolveRatingOptionText = (value, translationKey, languageKey) => {
    const resolvedKey = translationKey || RATING_VALUE_TO_STATIC_KEY[value];

    if (resolvedKey) {
        return getStaticFbsText(resolvedKey, languageKey);
    }

    return value ?? "";
};
